<template>
    <b-modal 
        :id="modalId + '-global-enabler-modal'" 
        modal-class="modal-template-default modal-global-enabler" 
        :header-class="headerClasses" 
        centered 
        hide-footer
    >
        <template v-slot:modal-header="{ close }">
            <h1 class="modal-title">{{ title }}</h1>

            <b-button v-on:click.prevent="close" class="close-modal-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="close-icon bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
            </b-button>
        </template>

        <slot/>

    </b-modal>
</template>

<script>
    export default {
        name: 'AppModalGlobalEnabler',

        props: {
            title: {
                default: '',
                type: String,
            },
            modalId: {
                default: '',
                type: String,
            },
            headerClasses: {
                default: '',
                type: String
            }
        },
    }
</script>

<style  lang="scss">
    .modal-global-enabler {
        @import "@/assets/scss/components/ui/modals/appModalTemplate";

        .modal-dialog {
            .modal-content {
                .modal-header {
                    border: none;
                    color: #ffff;

                    &.visa-color {
                        @include header-color-gradient(#22275f);
                    }

                    &.mc-color {
                        @include header-color-gradient(#ea001b);
                    }

                    &.ax-color {
                        @include header-color-gradient(#016fd0);
                    }

                    &.unionpay-color {
                        @include header-color-gradient(#fe9700);
                    }

                    &.dankort-color {
                        @include header-color-gradient(#22505F);
                    }

                    &.bank-axept-color {
                        @include header-color-gradient(#1EC21B);
                    }

                    &.eftpos-color {
                        @include header-color-gradient(#019ED0);
                    }

                    &.ai-modules-color {
                        @include header-color-gradient(#C01ACE);
                    }

                    &.program-design-color {
                        @include header-color-gradient(#00bbd3);
                    }

                    &.api-color {
                        @include header-color-gradient(#fec006);
                    }

                    &.crm-color {
                        @include header-color-gradient(#6639b6);
                    }

                    &.app-color {
                        @include header-color-gradient(#009587);
                    }

                    &.pages-color {
                        @include header-color-gradient(#f34235);
                    }

                    &.data-color {
                        @include header-color-gradient(#2095f2);
                    }

                    &.merchant-color {
                        @include header-color-gradient(#8ac249);
                    }

                    &.sign-up-color {
                        @include header-color-gradient(#fe5621);
                    }
                }
                            
            }
        }

    }
</style>
